import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from "@actinc/dls/components";
import './index.css';
import App from './App';
import { ApolloProvider } from '@apollo/client';
import graphqlApolloClient from './graphql/createapolloclient';
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme="ACT_ET">
    <ApolloProvider client={graphqlApolloClient}>
      <App />
    </ApolloProvider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 //reportWebVitals();
